import { schema } from 'normalizr'

export const tarifaReserva = new schema.Entity('tarifaReserva')
tarifaReserva.define({tarifasHijas: [tarifaReserva]})

export default {
  namespaced: true,
  state: {
    list: {}
  },
  mutations: {
    setAll (state, payload) {
      state.list = Object.assign({}, payload)
    }
  },
  actions: {
  },
  getters: {
    getAll (state) {
      return Object.keys(state.list).map(id => state.list[id])
    },
    getById (state) {
      return id => state.list[id]
    },
    getByCodigoActivo (state, getters) {
      return codigoActivo => getters.getAll.find(x => x.codigoActivo === codigoActivo)
    },
    getActual (state, getters) {
      return getters.getAll.find(x => x.tarifaReservaPadreId === null)
    },
    getHijas (state, getters) {
      return getters.getAll.filter(x => x.tarifaReservaPadreId !== null)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/reservas/_id/tarifas/store.js